import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { lenisStore } from "@/lib/scroll";
import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { EditorialMarquee } from "@/components/landing/Marquee";
import { Advantages } from "@/components/landing/Advantages";
import { Services } from "@/components/landing/Services";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { ZoneWhyContact } from "@/components/landing/ZoneWhyContact";
import { Faq } from "@/components/landing/Faq";
import { Contact } from "@/components/landing/Contact";
import { Footer } from "@/components/landing/Footer";
import { FloatingUI } from "@/components/landing/FloatingUI";
import MentionsLegales from "@/pages/MentionsLegales";
import PolitiqueConfidentialite from "@/pages/PolitiqueConfidentialite";

const Landing = () => (
    <>
        <Header />
        <main>
            <Hero />
            <Advantages />
            <Services />
            <EditorialMarquee />
            <HowItWorks />
            <ZoneWhyContact />
            <Faq />
            <Contact />
        </main>
        <Footer />
        <FloatingUI />
    </>
);

function App() {
    useEffect(() => {
        const lenis = new Lenis({
            duration: 1.2,
            anchors: true,
            smoothWheel: true,
        });
        lenisStore.current = lenis;
        let rafId;
        const loop = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(loop);
        };
        rafId = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            lenisStore.current = null;
        };
    }, []);

    return (
        <div className="App bg-midnight-900 text-white min-h-screen">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/mentions-legales" element={<MentionsLegales />} />
                    <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
